<template lang="pug">
  v-list(color="transparent")
    v-subheader.mb-3
      div(v-if="!multiple")
        .title Выберите набор
      div(v-else)
        .title.mb-1
          span Набор
          v-chip(
            small
          ).ml-3
            span Выбрано -
            strong.ml-1
              template(v-if="!value.length") для всех
              template(v-else) {{ value.length }}
            v-icon(
              v-if="value.length"
              right
              small
              @click="$emit('input', [])"
            ) mdi-close-circle
        .caption Выберите один или несколько
    v-list-item-group(
      :value="value"
      :multiple="multiple"
      @change="$emit('input', $event)"
    )
      v-list-item(
        v-for="record in items"
        :key="record.id"
        :value="record"
      ).my-2
        v-list-item-avatar
          v-avatar(color="secondary lighten-1").caption.white--text {{ record.code }}
        v-list-item-content
          v-list-item-subtitle
            | {{ record.start_learning | dp('d MMMM y') }} -
            |  {{ record.end_learning | dp('d MMMM y') }}
            .caption.opacity Период обучения
</template>

<script>
export default {
  props: {
    value: { type: [Array, Object], default: () => ([]) },
    items: { type: Array, default: () => ([]) },
    multiple: { type: Boolean, default: false },
  },
};
</script>
